import TextField from '@betterfunnel/ui-core/TextField';
import { useEffect, useMemo, useState } from 'react';
import SettingsHelpTooltip from './SettingsHelpTooltip';

interface Props {
  title?: string;
  helpText?: string;
  editable?: boolean;
  value?: string;
  setValue?: any;
  update?: any;
  pattern?: string;
  placeholder?: string;
}

export default function SettingSectionTextField({
  title,
  helpText,
  editable,
  value,
  setValue,
  update,
  pattern,
  placeholder = '',
}: Props) {
  const [editing, setEditing] = useState(false);
  const [initialValue, setInitialValue] = useState('');

  useEffect(() => {
    if (editing) {
      setInitialValue(value as string);
    }
  }, [editing]);

  const isValid = useMemo(() => {
    if (pattern && value) {
      return new RegExp(pattern).test(value);
    }
    return true;
  }, [value, pattern]);

  return (
    <div className="pt-6 sm:flex">
      <dt className="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">
        <div className="flex items-center gap-2">
          {title}
          {helpText && <SettingsHelpTooltip text={helpText} iconSize="sm" />}
        </div>
      </dt>
      <dd className="mt-1 flex justify-between gap-x-6 sm:mt-0 sm:flex-auto">
        {!editing ? (
          <div className="text-gray-900">{value}</div>
        ) : (
          <TextField
            key={'edit-name'}
            value={value}
            onChange={(v) => setValue(v.target.value)}
            validation={
              isValid ? undefined : { status: 'error', text: 'Invalid' }
            }
            placeholder={placeholder}
          />
        )}
        <div className="flex gap-4">
          {editing ? (
            <button
              type="button"
              className="font-semibold text-gray-600 hover:text-gray-500"
              onClick={() => {
                {
                  setValue(initialValue as string);
                  setEditing((a) => !a);
                }
              }}
            >
              Cancel
            </button>
          ) : (
            <></>
          )}
          {editable ? (
            <button
              type="button"
              className="font-semibold text-indigo-600 hover:text-indigo-500"
              disabled={!isValid}
              onClick={() => {
                setEditing((a) => !a);
                if (editing) {
                  update();
                }
              }}
            >
              {editing ? 'Save' : 'Edit'}
            </button>
          ) : (
            <></>
          )}
        </div>
      </dd>
    </div>
  );
}
